import makeFilterBox from "../../shared/containers/make_filter_box";

import MainFilters from "../components/main_filters";
import AdvancedFilters from "../components/advanced_filters";

import { breadcrumbsClickOverview } from "../actions/focus_view";

export default makeFilterBox(MainFilters, AdvancedFilters, breadcrumbsClickOverview);
